import type { LookAt } from "../state/stores";
import { hint } from "../state/touch";

/**
 * What the crosshair says about the entity under it: only the action it offers. The name, owner, licence and
 * placer used to be shown here too, but that line sat next to the crosshair and hid what the player was looking
 * at (owner feedback, 2026-10-12); the panel and the agent's get_plot still have those details.
 */
export function lookPrompt(l: LookAt | null): string {
  return l?.removable ? hint("[E] 移除", "點「移除」") : "";
}
